<!--
 * @Descripttion: 查看明细(综合服务费订单)
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <div class="order-detail-c">
    <xrk-table
      style="height: 650px"
      ref="xrkTableRef"
      :getListAjax="getListAjax"
      :searchConfig="searchConfig"
      :tableConfig="tableConfig"
    ></xrk-table>
  </div>
</template>

<script lang="tsx" setup>
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { XrkTable, XrkTableProps, XrkTableRef } from 'xrk-components';

import { comprehensiveViewDetails } from '../data-source/apis';
import {
  indexCol,
  fullNameCol,
  phoneCol,
  settlementTaskCountCol,
  taskPriceCol,
  projectPayPriceCol,
  comprehensiveServiceRateCol,
  comprehensiveServiceAmountCol,
  payStatusCol
} from '../fields/columns';
import {
  fullNameSearch,
  phoneSearch,
  payStatusSearch
} from '../fields/searchs';
import { ORDER_PAY_STATUS_PAY_SUCCESS } from '../constants';

const route = useRoute();

const detailInfo = computed(() => {
  return {
    id: +route.query.id
  };
});

const xrkTableRef = ref<XrkTableRef>();

// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: true,
    text: '搜索'
  },
  resetBtn: {
    show: true,
    text: '重置'
  },
  searchColumns: [
    fullNameSearch,
    phoneSearch,
    {
      ...payStatusSearch,
      config: {
        options: ORDER_PAY_STATUS_PAY_SUCCESS
      }
    }
  ],
  otherComponents: []
});

// 列表
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    indexCol,
    fullNameCol,
    phoneCol,
    settlementTaskCountCol,
    taskPriceCol,
    projectPayPriceCol,
    comprehensiveServiceRateCol,
    comprehensiveServiceAmountCol,
    {
      ...payStatusCol,
      formatter({ cellValue }) {
        return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
      }
    }
  ]
});

const getListAjax = async params => {
  const reqData = {
    ...params,
    id: detailInfo.value.id
  };
  const data = await comprehensiveViewDetails(reqData);
  return data;
};
</script>
<style lang="scss"></style>
